// Init Alpine.
document.addEventListener('DOMContentLoaded', () => {

    // Not needed since Livewire 3, see https://livewire.laravel.com/docs/installation#manually-bundling-livewire-and-alpine
    //window.Alpine.start();

    if(window.Livewire) {
        window.Livewire.start();

        // Intercept Livewire request errors to show friendly messages instead of the default error overlay.
        Livewire.hook('request', ({ fail }) => {
            fail(({ status, preventDefault }) => {
                preventDefault();

                if (status === 419) {
                    window.Swal && Swal.fire({
                        icon: 'warning',
                        title: 'Sessie verlopen',
                        text: 'Je sessie is verlopen. De pagina wordt opnieuw geladen.',
                        confirmButtonText: 'Herlaad pagina',
                        confirmButtonColor: '#4f46e5',
                        allowOutsideClick: false,
                    }).then(() => window.location.reload());
                    return;
                }

                if (status === 403) {
                    window.Swal && Swal.fire({
                        icon: 'error',
                        title: 'Geen toegang',
                        text: 'Je hebt geen rechten om deze actie uit te voeren.',
                        confirmButtonText: 'Sluiten',
                        confirmButtonColor: '#4f46e5',
                    });
                    return;
                }

                // 500 and other server errors
                console.error('Livewire request failed with status ' + status);

                window.Swal && Swal.fire({
                    icon: 'error',
                    title: 'Er ging iets mis',
                    text: 'Er is een onverwachte fout opgetreden. Probeer het later opnieuw of neem contact op met support.',
                    confirmButtonText: 'Sluiten',
                    confirmButtonColor: '#4f46e5',
                });
            });
        });
    }
});
